import React from 'react';
import { Link } from 'react-router-dom';
import { PageTitle } from '../../../components';
import { FaCalendarAlt, FaUsers, FaClock } from 'react-icons/fa';
import { legends } from '../../../constants';
import './LegendPage.css';

const LegendPage = () => {

    const featuredLegend = legends.find(item => item.id === 1);
    const otherLegends = legends.filter(item => item.id !== 1);

    return (
        <>
            <PageTitle title="Cykl Legend" page="Legendy Dworu" />

            {featuredLegend && (
                <section className='legend-single featured-section'>
                    <div className='container'>
                        <div className='legend-intro'>

                            <div className='image'>
                                <img src={featuredLegend.image} alt={featuredLegend.title} />
                            </div>

                            <div className='information'>
                                <h3>{featuredLegend.title}</h3>
                                <h5>{featuredLegend.subtitle}</h5>

                                <div className='legend-about'>
                                    <div className='text' style={{ whiteSpace: 'pre-line' }}>
                                        {featuredLegend.content}
                                    </div>
                                </div>

                                <ul className="legend-meta-info">
                                    <li><h6><FaCalendarAlt className='icon' /> Data:</h6><span>{featuredLegend.date}</span></li>
                                    <li><h6><FaUsers className='icon' /> Autor:</h6><span>{featuredLegend.author}</span></li>
                                    <li><h6><FaClock className='icon' /> Czas czytania:</h6><span>{featuredLegend.readTime}</span></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>
            )}

            <section className="legends-list-section" style={{ padding: '50px 0', background: '#f9f9f9' }}>
                <div className="container">
                    <h3 style={{ textAlign: 'center', marginBottom: '40px' }}>Kolejne części</h3>

                    <div className="legends-grid">
                        {otherLegends.map((item) => (
                            <div key={item.id} className="legend-card">

                                <div className="card-content">
                                    <h4>{item.title}</h4>
                                    <p>{item.subtitle}</p>

                                    <Link to={`/Legenda/${item.id}`} className="btn-read-more">
                                        Czytaj dalej
                                    </Link>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
};

export default LegendPage;